import {ApiHelper} from "../apiHelper";
import {IPagination, IQuery} from "../../models/athena";
import {Observable} from "rxjs";
import {BaseDao} from "./BaseDao";
import {ConstantMan} from "../constantMan";

export class AthenaDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.ATHENA, apiHelper);
    }

    public queryT(query: IQuery, pagination?: IPagination): Observable<any> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/query';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(
            url,
            'POST',
            null,
            { query: query, ...(pagination ? { pagination: pagination } : {})},
            headers);
    }
}
